import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { urls } from 'environments/environment';

@Injectable()
export class PixService {

  constructor(private http: HttpClient) { }

  obterTransacaoPix(transacaoPixId) {
    return this.http.get(`${urls.apiBase}/CobrancaPix/ObterPorId?cobrancaPixId=${transacaoPixId}`);
  }

  ObterComAtualizacaoRecebimentoPorId(transacaoPixId) {
    return this.http.get(`${urls.apiBase}/CobrancaPix/ObterComAtualizacaoRecebimentoPorId?cobrancaPixId=${transacaoPixId}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/pix/pix.service.ts